import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // window.scrollTo(0, 0);
    // using this for firefox
    document.documentElement.scrollTo(0, 0);
  }, [pathname, search]);

  return null;
}